import { render, staticRenderFns } from "./ExpedienteLista.vue?vue&type=template&id=5892f822&"
import script from "./ExpedienteLista.vue?vue&type=script&lang=js&"
export * from "./ExpedienteLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports